const setFeatureLayer = (state, payload) => {
  const index = state.layersBase.findIndex(x => x.Alias === payload.Alias)
  if (index === -1) return false
  state.layersBase[index] = payload
}
const setGeoPopLevels = (state, payload) => { state.geoPopLevels = payload }
const setLayersBase = (state, payload) => { state.layersBase = payload }
const setAddLayerBase = (state, payload) => { state.layersBase.unshift(payload) }
const setNewLayer = (state, payload) => { state.newLayer = payload }
const setStatusLayer = (state, payload) => { state.statusLayer = payload }
const updateDataVis = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis = payload.datavis
}
const updateStyle = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis.style = payload.style
}
const setRemoveLayerBase = (state, payload) => {
  // state.layersBase.splice(state.layersBase.findIndex(e => e === payload), 1)
  state.layersBase.splice(state.layersBase.findIndex(e => e.layer.gdIdEvent == payload.gdIdEvent))
}
const setLoading = (state, payload) => {
  state.loading = payload
}
const setLayersMenu = (state, payload) => {
  state.layersMenu = payload
}
const setEnvironment = (state, payload) => {
  state.environment = payload
}

export default {
  setEnvironment,
  setLayersMenu,
  setLoading,
  setGeoPopLevels,
  setLayersBase,
  setAddLayerBase,
  setRemoveLayerBase,
  setFeatureLayer,
  setNewLayer,
  setStatusLayer,
  updateDataVis,
  updateStyle
}
